/** Chaves `trips.*` MOVIDAS do `common.json` do web-chat (fase 2, move-only): são as que
 *  os arquivos deste pacote usam. The voucher document chrome (`voucherDoc.*`,
 *  `flightVoucher.*`, `voucherSkeleton.*`, #5001) lives here too: both hosts draw the kit's
 *  voucher documents with `voucherCopy()`. O web-chat espalha este catálogo no `resources` do
 *  i18next (como já faz com o do trip-document); o operador idem na fase 3. Fonte:
 *  pt-BR; `catalog.test.ts` garante paridade e cobertura das chaves literais. */
export const CATALOG = {
  'pt-BR': {
    'shell.tripFallback': 'Viagem sem nome',
    'trips.panel.askAnchorArrive': 'Chego às {{arrive}}.',
    'trips.panel.askAnchorBoth': 'Chego às {{arrive}} e meu voo de volta sai às {{depart}}.',
    'trips.panel.askAnchorBothNext': 'Chego às {{arrive}} e meu próximo voo sai às {{depart}}.',
    'trips.panel.askAnchorDepart': 'Meu voo de volta sai às {{depart}}.',
    'trips.panel.askAnchorDepartNext': 'Meu próximo voo sai às {{depart}}.',
    'trips.panel.askFlight.head': 'Preciso de um voo',
    'trips.panel.askFlight.headFromTo': 'Preciso de um voo de {{from}} para {{to}}',
    'trips.panel.askFlight.headTo': 'Preciso de um voo para {{to}}',
    'trips.panel.askFlight.window': 'ida {{start}} e volta {{end}}',
    'trips.panel.askGuests_one': 'para {{count}} hóspede',
    'trips.panel.askGuests_other': 'para {{count}} hóspedes',
    'trips.panel.askHotel.head': 'Preciso de um hotel',
    'trips.panel.askHotel.headIn': 'Preciso de um hotel em {{city}}',
    'trips.panel.askHotel.window': 'check-in {{start}} e check-out {{end}}',
    'trips.panel.askHotel.windowFrom': 'check-in {{start}}, ainda sem data de saída',
    'trips.panel.askNights_one': '{{count}} noite',
    'trips.panel.askNights_other': '{{count}} noites',
    'trips.panel.askPax_one': 'para {{count}} passageiro',
    'trips.panel.askPax_other': 'para {{count}} passageiros',
    'trips.panel.copyAddress': 'Copiar o endereço {{code}}',
    'trips.panel.arrivesAt': 'chega {{time}}',
    'trips.panel.awaitingApprover': 'Aguardando {{name}}',
    'trips.panel.copyLocator': 'Copiar o localizador {{code}}',
    'trips.panel.copyReservation': 'Copiar a reserva {{code}}',
    'trips.panel.copyVoucher': 'Copiar o voucher {{code}}',
    'trips.panel.openTravelerVoucher': 'Ver o voucher de {{name}}',
    'trips.panel.openVoucher': 'Ver o voucher de {{name}}',
    'trips.panel.step.outbound': 'Voo de ida',
    'trips.panel.step.return': 'Voo de volta',
    'trips.panel.step.checkIn': 'Check-in',
    'trips.panel.rebooked': 'Remarcado',
    'trips.panel.rebookedBefore': 'Antes: {{flight}} · {{date}} · {{time}}',
    'trips.panel.changeNoLive': 'Sem acompanhamento ao vivo enquanto a alteração não sai.',
    'trips.panel.returnAirportSwitch':
      'Aeroporto diferente: a volta parte de {{departure}} e a ida chega em {{arrival}}',
    'trips.panel.travelers_one': '{{count}} passageiro',
    'trips.panel.travelers_other': '{{count}} passageiros',
    'trips.pill.inDays': 'Em {{count}} dias',
    'trips.pill.ongoing': 'Iniciada',
    'trips.pill.today': 'Hoje',
    'trips.pill.tomorrow': 'Amanhã',
    'trips.pill.upcoming': 'Próxima',
    'trips.policy.needsApproval': 'Vai precisar de aprovação.',
    'trips.policy.out': 'Fora da política',
    'trips.provisional.guests_one': 'Hóspede',
    'trips.provisional.guests_other': 'Hóspedes',
    'trips.provisional.label': 'Reserva em andamento',
    'trips.provisional.note.bus.inProgress':
      'Reserva em andamento com a viação. Não precisa reenviar — as passagens aparecem aqui quando ela emitir.',
    'trips.provisional.note.bus.indeterminate':
      'Não deu para confirmar a reserva com a viação. Não reenvie: se ela existir, as passagens aparecem aqui quando a viação emitir.',
    'trips.provisional.note.bus.reserved':
      'Reserva garantida. Não precisa fazer nada — as passagens aparecem aqui quando a viação emitir.',
    'trips.provisional.note.mobility.inProgress':
      'Corrida em andamento com a cooperativa. Não precisa reenviar — os dados do motorista aparecem aqui quando ela aceitar.',
    'trips.provisional.note.mobility.indeterminate':
      'Não deu para confirmar a corrida com a cooperativa. Não reenvie: se ela existir, os dados do motorista aparecem aqui quando a cooperativa aceitar.',
    'trips.provisional.note.mobility.reserved':
      'Corrida solicitada. Não precisa fazer nada — os dados do motorista aparecem aqui quando a cooperativa aceitar.',
    'trips.provisional.note.rental.inProgress':
      'Reserva em andamento com a locadora. Não precisa reenviar — o localizador aparece aqui quando ela confirmar.',
    'trips.provisional.note.rental.indeterminate':
      'Não deu para confirmar a reserva com a locadora. Não reenvie: se ela existir, o localizador aparece aqui quando a locadora confirmar.',
    'trips.provisional.note.rental.reserved':
      'Reserva garantida. Não precisa fazer nada — o localizador aparece aqui quando a locadora confirmar.',
    'trips.provisional.note.hotel.inProgress':
      'Reserva em andamento com o hotel. Não precisa reenviar — o número da reserva aparece aqui quando ele confirmar.',
    'trips.provisional.note.hotel.indeterminate':
      'Não deu para confirmar a reserva com o hotel. Não reenvie: se ela existir, o número da reserva aparece aqui quando o hotel confirmar.',
    'trips.provisional.note.hotel.reserved':
      'Solicitação registrada. Não precisa fazer nada — o número da reserva aparece aqui quando o hotel confirmar.',
    'trips.provisional.note.inProgress':
      'Reserva em andamento com a companhia. Não precisa reenviar — os documentos aparecem aqui quando ela emitir.',
    'trips.provisional.note.indeterminate':
      'Não deu para confirmar a reserva com a companhia. Não reenvie: se ela existir, os documentos aparecem aqui quando ela emitir.',
    'trips.provisional.note.reserved':
      'Reserva garantida. Não precisa fazer nada — os documentos aparecem aqui quando a companhia emitir.',
    'trips.provisional.perTraveler': 'por passageiro',
    'trips.provisional.roundTrip': 'ida e volta',
    'trips.provisional.sameTicket': 'mesmo bilhete da ida',
    'trips.provisional.seats_one': 'Poltrona {{seats}}',
    'trips.provisional.seats_other': 'Poltronas {{seats}}',
    'trips.provisional.timeTbd': 'horário a confirmar',
    'trips.provisional.travelers_one': 'Passageiro',
    'trips.provisional.travelers_other': 'Passageiros',
    'trips.readiness.issued': 'Emitida',
    'trips.readiness.pending': 'Pendente',
    'trips.services.locatorShort': 'LOC',
    'trips.status.cancelled': 'Cancelada',
    'trips.status.completed': 'Concluída',
    'trips.status.ongoing': 'Em viagem',
    'trips.status.upcoming': 'Próxima',
    'trips.sugg.addChip': 'Adicionar',
    'trips.sugg.bagChip': 'Adicionar bagagem',
    'trips.sugg.seatChip': 'Adicionar assento',
    'flightVoucher.allowance.add': 'Adicionar bagagem',
    'flightVoucher.allowance.estimated':
      'O valor da bagagem extra é estimado. Nosso time confirma com a companhia antes de emitir.',
    'flightVoucher.allowance.included': 'Incluída',
    'flightVoucher.allowance.noneText':
      'A tarifa não inclui bagagem de mão nem bagagem despachada.',
    'flightVoucher.allowance.noneTitle': 'Sua tarifa não inclui bagagem',
    'flightVoucher.allowance.notIncluded': 'Não inclusa',
    'flightVoucher.allowance.title': 'Bagagem que você pode levar',
    'flightVoucher.allowance.unknown': 'Não informado',
    'flightVoucher.back': 'Voltar',
    'flightVoucher.cancelBaggage': 'Cancelar bagagem',
    'flightVoucher.cancelBooking': 'Cancelar reserva',
    'flightVoucher.cancelRequest': 'Cancelar solicitação',
    'flightVoucher.cancelSeat': 'Cancelar assento',
    'flightVoucher.email': 'Receber por e-mail',
    'flightVoucher.fareRules': 'Regras da tarifa',
    'flightVoucher.locator': 'Localizador',
    'flightVoucher.more': 'Mais ações do voucher',
    'flightVoucher.stopDetails': 'Detalhes',
    'voucherDoc.cancel': 'Cancelar voucher',
    'voucherDoc.cancelTooltip': 'Inicia o cancelamento deste voucher',
    'voucherDoc.close': 'Fechar o voucher',
    'voucherDoc.closeSr': 'Fechar voucher',
    'voucherDoc.copied': 'Copiado',
    'voucherDoc.copy': 'Copiar {{what}}',
    'voucherDoc.copyAria': 'Copiar {{value}}',
    'voucherDoc.copyFailed': 'Não foi possível copiar',
    'voucherDoc.copyFallback': 'para a área de transferência',
    'voucherDoc.moreInfo': 'Mais informações',
    'voucherDoc.moveToTrip': 'Mover para outra trip',
    'voucherDoc.newRequest': 'Nova solicitação',
    'voucherDoc.share': 'Compartilhar',
    'voucherDoc.shareTooltip': 'Copia o resumo do voucher para você colar onde quiser',
    'voucherDoc.talk': 'Falar sobre o voucher',
    'voucherDoc.talkTooltip': 'Abre a conversa já com este voucher no contexto',
    'voucherDoc.total': 'Valor total',
    'voucherSkeleton.request': 'Solicitação',
    'voucherSkeleton.status': 'Status: {{label}}',
    'voucherSkeleton.values': 'Valores',
  },
  en: {
    'shell.tripFallback': 'Unnamed trip',
    'trips.panel.askAnchorArrive': 'I land at {{arrive}}.',
    'trips.panel.askAnchorBoth': 'I land at {{arrive}} and my return flight departs at {{depart}}.',
    'trips.panel.askAnchorBothNext':
      'I land at {{arrive}} and my next flight departs at {{depart}}.',
    'trips.panel.askAnchorDepart': 'My return flight departs at {{depart}}.',
    'trips.panel.askAnchorDepartNext': 'My next flight departs at {{depart}}.',
    'trips.panel.askFlight.head': 'I need a flight',
    'trips.panel.askFlight.headFromTo': 'I need a flight from {{from}} to {{to}}',
    'trips.panel.askFlight.headTo': 'I need a flight to {{to}}',
    'trips.panel.askFlight.window': 'departing {{start}} and returning {{end}}',
    'trips.panel.askGuests_one': 'for {{count}} guest',
    'trips.panel.askGuests_other': 'for {{count}} guests',
    'trips.panel.askHotel.head': 'I need a hotel',
    'trips.panel.askHotel.headIn': 'I need a hotel in {{city}}',
    'trips.panel.askHotel.window': 'check-in {{start}} and check-out {{end}}',
    'trips.panel.askHotel.windowFrom': 'check-in {{start}}, check-out still open',
    'trips.panel.askNights_one': '{{count}} night',
    'trips.panel.askNights_other': '{{count}} nights',
    'trips.panel.askPax_one': 'for {{count}} passenger',
    'trips.panel.askPax_other': 'for {{count}} passengers',
    'trips.panel.copyAddress': 'Copy address {{code}}',
    'trips.panel.arrivesAt': 'arrives {{time}}',
    'trips.panel.awaitingApprover': 'Awaiting {{name}}',
    'trips.panel.copyLocator': 'Copy locator {{code}}',
    'trips.panel.copyReservation': 'Copy booking {{code}}',
    'trips.panel.copyVoucher': 'Copy voucher {{code}}',
    'trips.panel.openTravelerVoucher': "View {{name}}'s voucher",
    'trips.panel.openVoucher': 'View the {{name}} voucher',
    'trips.panel.step.outbound': 'Outbound flight',
    'trips.panel.step.return': 'Return flight',
    'trips.panel.step.checkIn': 'Check-in',
    'trips.panel.rebooked': 'Rebooked',
    'trips.panel.rebookedBefore': 'Before: {{flight}} · {{date}} · {{time}}',
    'trips.panel.changeNoLive': 'No live tracking until the change goes through.',
    'trips.panel.returnAirportSwitch':
      'Different airport: the return departs from {{departure}} and the outbound arrives at {{arrival}}',
    'trips.panel.travelers_one': '{{count}} traveler',
    'trips.panel.travelers_other': '{{count}} travelers',
    'trips.pill.inDays': 'In {{count}} days',
    'trips.pill.ongoing': 'Started',
    'trips.pill.today': 'Today',
    'trips.pill.tomorrow': 'Tomorrow',
    'trips.pill.upcoming': 'Upcoming',
    'trips.policy.needsApproval': 'Will need approval.',
    'trips.policy.out': 'Out of policy',
    'trips.provisional.guests_one': 'Guest',
    'trips.provisional.guests_other': 'Guests',
    'trips.provisional.label': 'Booking in progress',
    'trips.provisional.note.bus.inProgress':
      'The booking is being processed with the bus company. No need to send it again — the tickets show up here once it issues them.',
    'trips.provisional.note.bus.indeterminate':
      "We couldn't confirm the booking with the bus company. Don't send it again: if it exists, the tickets show up here once the bus company issues them.",
    'trips.provisional.note.bus.reserved':
      'The booking is secured. Nothing else to do — the tickets show up here once the bus company issues them.',
    'trips.provisional.note.mobility.inProgress':
      'The ride is being processed with the cooperative. No need to send it again — the driver details show up here once it accepts.',
    'trips.provisional.note.mobility.indeterminate':
      "We couldn't confirm the ride with the cooperative. Don't send it again: if it exists, the driver details show up here once the cooperative accepts.",
    'trips.provisional.note.mobility.reserved':
      'Ride requested. Nothing else to do — the driver details show up here once the cooperative accepts.',
    'trips.provisional.note.rental.inProgress':
      'The booking is being processed with the rental company. No need to send it again — the confirmation code shows up here once it confirms.',
    'trips.provisional.note.rental.indeterminate':
      "We couldn't confirm the booking with the rental company. Don't send it again: if it exists, the confirmation code shows up here once the rental company confirms.",
    'trips.provisional.note.rental.reserved':
      'The booking is secured. Nothing else to do — the confirmation code shows up here once the rental company confirms.',
    'trips.provisional.note.hotel.inProgress':
      'The booking is being processed with the hotel. No need to send it again — the booking number shows up here once it confirms.',
    'trips.provisional.note.hotel.indeterminate':
      "We couldn't confirm the booking with the hotel. Don't send it again: if it exists, the booking number shows up here once the hotel confirms.",
    'trips.provisional.note.hotel.reserved':
      'Request registered. Nothing else to do — the booking number shows up here once the hotel confirms.',
    'trips.provisional.note.inProgress':
      'The booking is being processed with the airline. No need to send it again — the documents show up here once it issues them.',
    'trips.provisional.note.indeterminate':
      "We couldn't confirm the booking with the airline. Don't send it again: if it exists, the documents show up here once it issues them.",
    'trips.provisional.note.reserved':
      'The booking is secured. Nothing else to do — the documents show up here once the airline issues them.',
    'trips.provisional.perTraveler': 'per traveler',
    'trips.provisional.roundTrip': 'round trip',
    'trips.provisional.sameTicket': 'same ticket as the outbound',
    'trips.provisional.seats_one': 'Seat {{seats}}',
    'trips.provisional.seats_other': 'Seats {{seats}}',
    'trips.provisional.timeTbd': 'time to be confirmed',
    'trips.provisional.travelers_one': 'Traveler',
    'trips.provisional.travelers_other': 'Travelers',
    'trips.readiness.issued': 'Issued',
    'trips.readiness.pending': 'Pending',
    'trips.services.locatorShort': 'LOC',
    'trips.status.cancelled': 'Cancelled',
    'trips.status.completed': 'Completed',
    'trips.status.ongoing': 'In progress',
    'trips.status.upcoming': 'Upcoming',
    'trips.sugg.addChip': 'Add',
    'trips.sugg.bagChip': 'Add baggage',
    'trips.sugg.seatChip': 'Add seat',
    'flightVoucher.allowance.add': 'Add baggage',
    'flightVoucher.allowance.estimated':
      'The extra baggage price is an estimate. Our team confirms it with the airline before issuing.',
    'flightVoucher.allowance.included': 'Included',
    'flightVoucher.allowance.noneText': 'The fare includes neither carry-on nor checked baggage.',
    'flightVoucher.allowance.noneTitle': 'Your fare includes no baggage',
    'flightVoucher.allowance.notIncluded': 'Not included',
    'flightVoucher.allowance.title': 'Baggage you can take',
    'flightVoucher.allowance.unknown': 'Not stated',
    'flightVoucher.back': 'Back',
    'flightVoucher.cancelBaggage': 'Cancel baggage',
    'flightVoucher.cancelBooking': 'Cancel booking',
    'flightVoucher.cancelRequest': 'Cancel request',
    'flightVoucher.cancelSeat': 'Cancel seat',
    'flightVoucher.email': 'Get it by email',
    'flightVoucher.fareRules': 'Fare rules',
    'flightVoucher.locator': 'Locator',
    'flightVoucher.more': 'More voucher actions',
    'flightVoucher.stopDetails': 'Details',
    'voucherDoc.cancel': 'Cancel voucher',
    'voucherDoc.cancelTooltip': 'Starts the cancellation of this voucher',
    'voucherDoc.close': 'Close the voucher',
    'voucherDoc.closeSr': 'Close voucher',
    'voucherDoc.copied': 'Copied',
    'voucherDoc.copy': 'Copy {{what}}',
    'voucherDoc.copyAria': 'Copy {{value}}',
    'voucherDoc.copyFailed': "Couldn't copy",
    'voucherDoc.copyFallback': 'to the clipboard',
    'voucherDoc.moreInfo': 'More information',
    'voucherDoc.moveToTrip': 'Move to another trip',
    'voucherDoc.newRequest': 'New request',
    'voucherDoc.share': 'Share',
    'voucherDoc.shareTooltip': 'Copies the voucher summary for you to paste anywhere',
    'voucherDoc.talk': 'Talk about this voucher',
    'voucherDoc.talkTooltip': 'Opens the conversation with this voucher already in context',
    'voucherDoc.total': 'Total amount',
    'voucherSkeleton.request': 'Request',
    'voucherSkeleton.status': 'Status: {{label}}',
    'voucherSkeleton.values': 'Amounts',
  },
  es: {
    'shell.tripFallback': 'Viaje sin nombre',
    'trips.panel.askAnchorArrive': 'Llego a las {{arrive}}.',
    'trips.panel.askAnchorBoth':
      'Llego a las {{arrive}} y mi vuelo de vuelta sale a las {{depart}}.',
    'trips.panel.askAnchorBothNext':
      'Llego a las {{arrive}} y mi próximo vuelo sale a las {{depart}}.',
    'trips.panel.askAnchorDepart': 'Mi vuelo de vuelta sale a las {{depart}}.',
    'trips.panel.askAnchorDepartNext': 'Mi próximo vuelo sale a las {{depart}}.',
    'trips.panel.askFlight.head': 'Necesito un vuelo',
    'trips.panel.askFlight.headFromTo': 'Necesito un vuelo de {{from}} a {{to}}',
    'trips.panel.askFlight.headTo': 'Necesito un vuelo a {{to}}',
    'trips.panel.askFlight.window': 'ida {{start}} y vuelta {{end}}',
    'trips.panel.askGuests_one': 'para {{count}} huésped',
    'trips.panel.askGuests_other': 'para {{count}} huéspedes',
    'trips.panel.askHotel.head': 'Necesito un hotel',
    'trips.panel.askHotel.headIn': 'Necesito un hotel en {{city}}',
    'trips.panel.askHotel.window': 'entrada {{start}} y salida {{end}}',
    'trips.panel.askHotel.windowFrom': 'entrada {{start}}, salida aún sin fecha',
    'trips.panel.askNights_one': '{{count}} noche',
    'trips.panel.askNights_other': '{{count}} noches',
    'trips.panel.askPax_one': 'para {{count}} pasajero',
    'trips.panel.askPax_other': 'para {{count}} pasajeros',
    'trips.panel.copyAddress': 'Copiar la dirección {{code}}',
    'trips.panel.arrivesAt': 'llega {{time}}',
    'trips.panel.awaitingApprover': 'Esperando a {{name}}',
    'trips.panel.copyLocator': 'Copiar el localizador {{code}}',
    'trips.panel.copyReservation': 'Copiar la reserva {{code}}',
    'trips.panel.copyVoucher': 'Copiar el voucher {{code}}',
    'trips.panel.openTravelerVoucher': 'Ver el voucher de {{name}}',
    'trips.panel.openVoucher': 'Ver el voucher de {{name}}',
    'trips.panel.step.outbound': 'Vuelo de ida',
    'trips.panel.step.return': 'Vuelo de vuelta',
    'trips.panel.step.checkIn': 'Check-in',
    'trips.panel.rebooked': 'Reprogramado',
    'trips.panel.rebookedBefore': 'Antes: {{flight}} · {{date}} · {{time}}',
    'trips.panel.changeNoLive': 'Sin seguimiento en vivo hasta que se complete el cambio.',
    'trips.panel.returnAirportSwitch':
      'Aeropuerto distinto: la vuelta sale de {{departure}} y la ida llega a {{arrival}}',
    'trips.panel.travelers_one': '{{count}} pasajero',
    'trips.panel.travelers_other': '{{count}} pasajeros',
    'trips.pill.inDays': 'En {{count}} días',
    'trips.pill.ongoing': 'Iniciado',
    'trips.pill.today': 'Hoy',
    'trips.pill.tomorrow': 'Mañana',
    'trips.pill.upcoming': 'Próximo',
    'trips.policy.needsApproval': 'Va a necesitar aprobación.',
    'trips.policy.out': 'Fuera de la política',
    'trips.provisional.guests_one': 'Huésped',
    'trips.provisional.guests_other': 'Huéspedes',
    'trips.provisional.label': 'Reserva en curso',
    'trips.provisional.note.bus.inProgress':
      'La reserva se está procesando con la empresa de autobuses. No hace falta enviarla de nuevo — los pasajes aparecen aquí cuando los emita.',
    'trips.provisional.note.bus.indeterminate':
      'No pudimos confirmar la reserva con la empresa de autobuses. No la envíes de nuevo: si existe, los pasajes aparecen aquí cuando la empresa de autobuses los emita.',
    'trips.provisional.note.bus.reserved':
      'La reserva está garantizada. No hace falta hacer nada — los pasajes aparecen aquí cuando la empresa de autobuses los emita.',
    'trips.provisional.note.mobility.inProgress':
      'El viaje se está procesando con la cooperativa. No hace falta enviarlo de nuevo — los datos del conductor aparecen aquí cuando lo acepte.',
    'trips.provisional.note.mobility.indeterminate':
      'No pudimos confirmar el viaje con la cooperativa. No lo envíes de nuevo: si existe, los datos del conductor aparecen aquí cuando la cooperativa lo acepte.',
    'trips.provisional.note.mobility.reserved':
      'Viaje solicitado. No hace falta hacer nada — los datos del conductor aparecen aquí cuando la cooperativa lo acepte.',
    'trips.provisional.note.rental.inProgress':
      'La reserva se está procesando con la rentadora. No hace falta enviarla de nuevo — el localizador aparece aquí cuando la confirme.',
    'trips.provisional.note.rental.indeterminate':
      'No pudimos confirmar la reserva con la rentadora. No la envíes de nuevo: si existe, el localizador aparece aquí cuando la rentadora la confirme.',
    'trips.provisional.note.rental.reserved':
      'La reserva está garantizada. No hace falta hacer nada — el localizador aparece aquí cuando la rentadora la confirme.',
    'trips.provisional.note.hotel.inProgress':
      'La reserva se está procesando con el hotel. No hace falta enviarla de nuevo — el número de reserva aparece aquí cuando lo confirme.',
    'trips.provisional.note.hotel.indeterminate':
      'No pudimos confirmar la reserva con el hotel. No la envíes de nuevo: si existe, el número de reserva aparece aquí cuando el hotel la confirme.',
    'trips.provisional.note.hotel.reserved':
      'Solicitud registrada. No hace falta hacer nada — el número de reserva aparece aquí cuando el hotel la confirme.',
    'trips.provisional.note.inProgress':
      'La reserva se está procesando con la aerolínea. No hace falta enviarla de nuevo — los documentos aparecen aquí cuando la emita.',
    'trips.provisional.note.indeterminate':
      'No pudimos confirmar la reserva con la aerolínea. No la envíes de nuevo: si existe, los documentos aparecen aquí cuando la emita.',
    'trips.provisional.note.reserved':
      'La reserva está garantizada. No hace falta hacer nada — los documentos aparecen aquí cuando la aerolínea los emita.',
    'trips.provisional.perTraveler': 'por pasajero',
    'trips.provisional.roundTrip': 'ida y vuelta',
    'trips.provisional.sameTicket': 'mismo billete que la ida',
    'trips.provisional.seats_one': 'Asiento {{seats}}',
    'trips.provisional.seats_other': 'Asientos {{seats}}',
    'trips.provisional.timeTbd': 'hora por confirmar',
    'trips.provisional.travelers_one': 'Pasajero',
    'trips.provisional.travelers_other': 'Pasajeros',
    'trips.readiness.issued': 'Emitida',
    'trips.readiness.pending': 'Pendiente',
    'trips.services.locatorShort': 'LOC',
    'trips.status.cancelled': 'Cancelado',
    'trips.status.completed': 'Completado',
    'trips.status.ongoing': 'En viaje',
    'trips.status.upcoming': 'Próximo',
    'trips.sugg.addChip': 'Agregar',
    'trips.sugg.bagChip': 'Agregar equipaje',
    'trips.sugg.seatChip': 'Agregar asiento',
    'flightVoucher.allowance.add': 'Agregar equipaje',
    'flightVoucher.allowance.estimated':
      'El valor del equipaje extra es estimado. Nuestro equipo lo confirma con la aerolínea antes de emitir.',
    'flightVoucher.allowance.included': 'Incluido',
    'flightVoucher.allowance.noneText':
      'La tarifa no incluye equipaje de mano ni equipaje facturado.',
    'flightVoucher.allowance.noneTitle': 'Tu tarifa no incluye equipaje',
    'flightVoucher.allowance.notIncluded': 'No incluido',
    'flightVoucher.allowance.title': 'Equipaje que puedes llevar',
    'flightVoucher.allowance.unknown': 'No informado',
    'flightVoucher.back': 'Volver',
    'flightVoucher.cancelBaggage': 'Cancelar equipaje',
    'flightVoucher.cancelBooking': 'Cancelar reserva',
    'flightVoucher.cancelRequest': 'Cancelar solicitud',
    'flightVoucher.cancelSeat': 'Cancelar asiento',
    'flightVoucher.email': 'Recibir por correo',
    'flightVoucher.fareRules': 'Reglas de la tarifa',
    'flightVoucher.locator': 'Localizador',
    'flightVoucher.more': 'Más acciones del voucher',
    'flightVoucher.stopDetails': 'Detalles',
    'voucherDoc.cancel': 'Cancelar voucher',
    'voucherDoc.cancelTooltip': 'Inicia la cancelación de este voucher',
    'voucherDoc.close': 'Cerrar el voucher',
    'voucherDoc.closeSr': 'Cerrar voucher',
    'voucherDoc.copied': 'Copiado',
    'voucherDoc.copy': 'Copiar {{what}}',
    'voucherDoc.copyAria': 'Copiar {{value}}',
    'voucherDoc.copyFailed': 'No se pudo copiar',
    'voucherDoc.copyFallback': 'al portapapeles',
    'voucherDoc.moreInfo': 'Más información',
    'voucherDoc.moveToTrip': 'Mover a otro viaje',
    'voucherDoc.newRequest': 'Nueva solicitud',
    'voucherDoc.share': 'Compartir',
    'voucherDoc.shareTooltip': 'Copia el resumen del voucher para que lo pegues donde quieras',
    'voucherDoc.talk': 'Hablar sobre el voucher',
    'voucherDoc.talkTooltip': 'Abre la conversación con este voucher ya en contexto',
    'voucherDoc.total': 'Valor total',
    'voucherSkeleton.request': 'Solicitud',
    'voucherSkeleton.status': 'Estado: {{label}}',
    'voucherSkeleton.values': 'Valores',
  },
} as const;
